module.exports = __webpack_public_path__ + "img/bghero1.0b20a87a.jpg";